document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("hero-video")) {
    customElements.define(
      "hero-video",
      class HeroVideo extends HTMLElement {
        constructor() {
          super();
          this.video = this.querySelector("video");
          this.videoDeskSrc = this.video.getAttribute("data-src");
          this.videoMobileSrc = this.video.getAttribute("data-mobile-src");
          this.prevWidth = window.innerWidth;

          this.soundBtn = this.querySelector("[data-sound]");
          this.handleSound = this.handleSound.bind(this);
          this.soundBtn?.addEventListener("click", this.handleSound);

          this.changeVideoSource = this.changeVideoSource.bind(this);
          window.addEventListener("resize", this.changeVideoSource);
          this.changeVideoSource();
        }

        handleSound() {
          if (this.video.muted) {
            this.video.muted = false;
            this.soundBtn.classList.remove("muted");
          } else {
            this.video.muted = true;
            this.soundBtn.classList.add("muted");
          }
        }

        connectedCallback() {
          const handleIntersection = (entries, observer) => {
            try {
              if (!this.video) return;
              if (entries[0].isIntersecting) {
                this.video.play();
              } else {
                this.video.pause();
              }
            } catch (error) {
              console.log(error);
            }
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            threshold: 0.5,
          }).observe(this.video);
        }
        changeVideoSource() {
          if (!this.video) return;

          const currentWidth = window.innerWidth;
          let newSrc;
          if (window.innerWidth >= 993 && this.videoDeskSrc) {
            newSrc = this.videoDeskSrc;
          } else if (window.innerWidth < 993 && this.videoMobileSrc) {
            newSrc = this.videoMobileSrc;
          } else {
            this.video.removeAttribute("src");
          }

          if (newSrc && newSrc !== this.video?.src) {
            this.video.src = newSrc;
          }
          this.prevWidth = currentWidth;
        }
      }
    );
  }

  if (!customElements.get("youtube-video")) {
    customElements.define(
      "youtube-video",
      class YoutubeVideo extends HTMLElement {
        constructor() {
          super();
          this.player = this.querySelector("[data-desktop-video]");
          this.player_mob = null;
          this.isMuted = true;
          this.soundBtn = this.querySelector("[data-sound]");
          this.handleSound = this.handleSound.bind(this);
          this.soundBtn?.addEventListener("click", this.handleSound);

          this.initYouTubePlayerAPI = this.initYouTubePlayerAPI.bind(this);

          this.playVideo = this.playVideo.bind(this);
          this.pauseVideo = this.pauseVideo.bind(this);
          this.mute = this.mute.bind(this);
          this.unMute = this.unMute.bind(this);

          this.videoDeskSrc = this.player.getAttribute("data-src");
          this.videoMobileSrc = this.player.getAttribute("data-mobile-src");

          this.changeVideoSource = this.changeVideoSource.bind(this);
          window.addEventListener("resize", this.changeVideoSource);
          this.changeVideoSource();
        }

        connectedCallback() {
          this.initYouTubePlayerAPI();
        }

        handleSound() {
          if (this.player && this.isMuted) {
            this.unMute();
          } else if (this.player) {
            this.mute();
          }
        }

        changeVideoSource() {
          if (!this.player) return;

          let newSrc;
          if (window.innerWidth >= 993 && this.videoDeskSrc) {
            newSrc = this.videoDeskSrc;
          } else if (window.innerWidth < 993 && this.videoMobileSrc) {
            newSrc = this.videoMobileSrc;
          } else {
            this.player.removeAttribute("src");
          }

          if (newSrc && newSrc !== this.player?.src) {
            this.player.src = newSrc;
            this.mute();
          }
        }

        initYouTubePlayerAPI() {
          const handleIntersection = (entries, observer) => {
            try {
              if (!this.player) return;

              if (entries[0].isIntersecting) {
                this.playVideo();
              } else {
                this.pauseVideo();
              }
            } catch (error) {
              console.log(error);
            }
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            threshold: 0.5,
          }).observe(this.player);
        }

        postMessageToPlayer(func) {
          this.player.contentWindow.postMessage(`{"event":"command","func":"${func}","args":""}`, "*");
        }

        pauseVideo() {
          this.postMessageToPlayer("pauseVideo");
        }

        playVideo() {
          this.postMessageToPlayer("playVideo");
        }

        mute() {
          this.postMessageToPlayer("mute");
          this.isMuted = true;
          this.soundBtn?.classList.add("muted");
        }

        unMute() {
          this.postMessageToPlayer("unMute");
          this.isMuted = false;
          this.soundBtn?.classList.remove("muted");
        }
      }
    );
  }
});
